import { render, staticRenderFns } from "./PolarizationMalusProViz.vue?vue&type=template&id=bcb07512&scoped=true"
import script from "./PolarizationMalusProViz.vue?vue&type=script&lang=js"
export * from "./PolarizationMalusProViz.vue?vue&type=script&lang=js"
import style0 from "./PolarizationMalusProViz.vue?vue&type=style&index=0&id=bcb07512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb07512",
  null
  
)

export default component.exports